import { workTypeApi } from '@/api'
import { getWorkTypeIdByName } from '@/scripts/consts'
import { vm } from '@/main'

export default {
  namespaced: true,

  state: {
    workTypes: []
  },

  getters: {
    workTypes: state => state.workTypes,
    workTypeByName: state => name => {
      const workTypeId = getWorkTypeIdByName(name)
      return state.workTypes.find(workType => workType.id === workTypeId)
    },
    workTypeRusName: state => name => {
      const workTypeId = getWorkTypeIdByName(name)
      return state.workTypes.find(workType => workType.id === workTypeId)?.name
    }
  },

  mutations: {
    setWorkTypes(state, payload) {
      if (payload) state.workTypes = payload.filter(el => el.isActual).toSorted((a, b) => a.inOrder - b.inOrder)
    }
  },

  actions: {
    async getWorkTypes({ state, commit }) {
      try {
        if (!state.workTypes.length) {
          const workTypes = await workTypeApi.getCatalog()
          if (workTypes) commit('setWorkTypes', workTypes)
        }
      } catch (e) {
        console.log(e)
        vm.showErrorMessage(e, 'Не удалось получить список типов работ')
      }
    }
  }
}
